import * as React from 'react';
import {ApolloProvider} from 'react-apollo';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {Router} from 'react-router-dom';

import {ApolloProvider as ReactHooksApolloProvider} from '@apollo/react-hooks';

import {nutApolloClient} from '../../../apollo-client';
import {appHistory} from '../../../history';
import {store} from '../../../store';

import {DirectorySyncSetup} from './directory-sync-setup';

export function mountDirectorySync(userId: string) {
    const directorySyncMount = document.getElementById('directory-sync-mount-for-react');

    if (directorySyncMount) {
        ReactDOM.render(
            <Provider store={store}>
                <ApolloProvider client={nutApolloClient}>
                    <ReactHooksApolloProvider client={nutApolloClient}>
                        <Router history={appHistory}>
                            <DirectorySyncSetup userId={userId} />
                        </Router>
                    </ReactHooksApolloProvider>
                </ApolloProvider>
            </Provider>,
            directorySyncMount
        );
    }
}
